module.exports = __webpack_public_path__ + "19a6f82563d7f2275fc41312b0f61c4f.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bnpb-logo.png
// module id = 1489
// module chunks = 1